import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_OPTIMIZELY_EVENT_SAFELIST = createFcmDetails('optimizely_event_safelist', {
	owner: 'Site-Platform',
	context: 'front-end (optimizely)',
	description: `
When the front-end tracks an event, if that event is part of this safe list, the even will be also sent to Optimizely using "optimizely.push()".

Related FCM: optimizely_property_safelist
	`,
	template: ['petition_view'],
	import: false,
});
